import { render, staticRenderFns } from "./pagoCertificado.vue?vue&type=template&id=470f9dd1&scoped=true&"
import script from "./pagoCertificado.vue?vue&type=script&lang=js&"
export * from "./pagoCertificado.vue?vue&type=script&lang=js&"
import style0 from "./pagoCertificado.vue?vue&type=style&index=0&id=470f9dd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f9dd1",
  null
  
)

export default component.exports